// Filtert de projectenlijst van het projectenoverzicht op sector
// (CompagnyMeta.SelectedSectors — hetzelfde veld dat Instellingen → Algemeen
// en onboarding stap 3 schrijven).
//
// De sectorkeuze is een van drie dingen:
//   'all'   → geen filter (ook de terugval bij een lege/onbekende keuze)
//   'none'  → tenants zonder sector; ontbrekend veld, null en [] tellen alle
//             drie als "nog niet ingevuld"
//   <slug>  → tenants die deze sector in hun lijst hebben (een tenant mag er
//             meerdere hebben, dus dit is een `includes`, geen gelijkheid)
//
// @param {Array<{SelectedSectors?: string[]}>} [projects] - CompagnyMeta-documenten
// @param {string} [sector] - 'all' | 'none' | een sector-slug
// @returns {Array<object>} een nieuwe array; de invoer blijft ongemoeid
const filterProjectsBySector = (projects, sector) => {

    const list = Array.isArray(projects) ? projects : []

    if (!sector || sector === 'all') return [...list]

    if (sector === 'none') {
        return list.filter((project) => {
            const sectors = project?.SelectedSectors
            return !Array.isArray(sectors) || sectors.length === 0
        })
    }

    return list.filter((project) =>
        Array.isArray(project?.SelectedSectors) && project.SelectedSectors.includes(sector)
    )
}

export default filterProjectsBySector
